import { render } from "./BootstrapTable.vue?vue&type=template&id=3d197a28&scoped=true"
import script from "./BootstrapTable.vue?vue&type=script&lang=js"
export * from "./BootstrapTable.vue?vue&type=script&lang=js"

import "./BootstrapTable.vue?vue&type=style&index=0&id=3d197a28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d197a28"]])

export default __exports__